<template>
  <div>
    <div class="banner-container">
      <div class="banner-overlay">
        <div class="container h-100">
          <div class="row h-100">
            <div class="col-lg-6 logo-wrapper">
              <h1 class="banner-heading">Pilates Haven</h1>
              <hr />
              <p class="banner-content">
                Pilates classes in Beccles
              </p>
              <router-link to="/contact-us/" class="btn btn-lg banner-link mb-4"
                >Contact Us</router-link
              >
              <a href="/docs/pilates_haven_leaflet.pdf" target="_blank" class="btn btn-lg banner-link">More Information</a>
            </div>
          </div>
        </div>
      </div>
      <div class="row triangle">
        <div class="col-lg-6"></div>
        <div class="col-lg-6">
          <div class="image-partial">
            <div class="img-cover"></div>
          </div>
        </div>
      </div>
    </div>

    <div id="our-services" class="our-services">
      <div class="container">
        <div class="row align-items-center">
          <div class="col-12">
            <h2 class="our-services-title">Our Services</h2>
            <hr class="section-hr" />
          </div>
        </div>

        <div class="row gap">
          <div
            v-for="service in services"
            :key="service.name"
            class="service-card col-md-6"
          >
            <img
              class="service-card-img"
              :src="service.imgSrc"
              :alt="service.imgAltText"
            />
            <div class="service-card-content">
              <h3 class="service-card-title">{{ service.name }}</h3>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import services from '@/lib/services'

export default {
  name: 'home',
  data () {
    return {
      services
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only if required -->
<style lang="scss" scoped>
@import "../../assets/styles/variables/colors";
@import "../../assets/styles/variables/breakpoints";

h2 {
  color: $clr-theme-black;
}

.section-hr {
  width: 100%;
  margin-top: 1.5rem;
  margin-bottom: 2rem;

  border-top: 5px solid $clr-theme-red;
}

.btn:hover {
  color: $black;
}

/****************************
    BANNER
*****************************/
.banner-container {
  background-color: $clr-theme-black;
  position: relative;

  .triangle {
    overflow: hidden;
  }

  .banner-overlay {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    color: $white;
    padding-top: 0;
    z-index: 2;
    overflow: hidden;
    background-color: rgba(0, 0, 0, 0.7);
    text-align: center;

    .logo-wrapper {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;

      @media (min-width: $md-breakpoint) {
        align-items: flex-start;
      }
    }

    @media (min-width: $md-breakpoint) {
      text-align: left;
      background-color: revert;
    }

    .banner-heading {
      color: $white;
      font-size: 2rem;
      text-transform: uppercase;
      font-weight: 700;
      margin-top: -10px;
      margin-bottom: 20px;

      @media (min-width: $sm-breakpoint) {
        font-size: 50px;
      }

      @media (min-width: $md-breakpoint) {
        font-size: 2rem;
      }

      @media (min-width: $lg-breakpoint) {
        font-size: 3rem;
      }
    }

    hr {
      width: 70%;

      margin: 0;
      margin-bottom: 45px;
      margin-left: auto;
      border-top: 5px solid $white;
      text-align: center;
      margin-left: 0;

      @media (min-width: $md-breakpoint) {
        width: 100%;
      }
    }

    .banner-content {
      font-weight: 400;
      font-size: 16px;
      margin-bottom: 45px;
      @media (min-width: $sm-breakpoint) {
        font-size: 18px;
      }

      @media (min-width: $lg-breakpoint) {
        font-size: 20px;
      }
    }
  }

  > .row {
    margin: 0;

    @media (min-width: $md-breakpoint) {
      :last-child::after,
      :last-child::before {
        content: "";
        display: block;
        position: absolute;
        left: -104px;
        width: 0;
        height: 0;
        border-style: solid;
      }

      // controls the color of the triangle
      *:last-child::after {
        top: -10px;
        border-color: transparent transparent transparent $clr-theme-black;
        border-bottom-width: 360px;
        border-top-width: 360px;
        border-left: 250px solid $clr-theme-black;
        left: -164px;
      }

      // controls the white border
      *:last-child::before {
        top: -10px; //0
        border-color: transparent transparent transparent $white;
        border-bottom-width: 360px;
        border-top-width: 360px;
        border-left: 250px solid $white;
        left: -155px;
      }
    }

    > * {
      padding: 0;
      position: relative;

      .image-partial {
        margin-left: -160px;

        .img-cover {
          background-image: url("/images/761a1008_ILDR1.jpg");
          height: 700px;
          display: block;
          background-repeat: no-repeat;
          background-position: center center;
          background-size: cover;

          @media (min-width: $md-breakpoint) {
            background-position: left center;
          }
        }
      }
    }
  }
}
/****************************
    ABOUT US
*****************************/
.about-us {
  padding: 64px 0;

  &-img {
    border-radius: 8px;
    width: 100%;
    height: 100%;
    object-fit: cover;
    vertical-align: baseline;
  }

  &-title {
    font-size: 40px;
  }
}
/****************************
    WORKING WITH
*****************************/
.working-with {
  padding: 64px 0;
  @media (max-width: $md-breakpoint) {
    padding: 0 0 64px 0;
  }
  &-title {
    font-size: 40px;
  }
  .client-logo {
    display: flex;
    align-items: center;
    justify-content: center;
    img {
      height: 65px;
      width: 100%;
      object-fit: contain;
    }
  }
}
/****************************
    SERVICES
*****************************/
.our-services {
  padding: 64px 0;
  background-color: $clr-theme-light-gray;

  .section-hr {
    width: 150px;
  }

  .gap {
    row-gap: 30px;
  }

  &-title {
    padding: 0;
    font-size: 40px;
  }

  .service-card {
    display: flex;
    flex-direction: column;

    &-img {
      width: 100%;
      object-fit: cover;
      border-radius: 10px 10px 0 0;
    }

    &-content {
      flex-grow: 1;
      padding: 1.5rem;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;

      background-color: $clr-theme-black;
      color: $white;
      text-align: center;
      border-radius: 0 0 10px 10px;

      @media (min-width: $md-breakpoint) {
        padding: 2rem;
      }
    }

    &-title {
      margin: 0;
      font-size: 1.5rem;

      font-weight: 500;
      line-height: 1.35;
      letter-spacing: 0.03em;

      @media (min-width: $md-breakpoint) {
        font-size: 2rem;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/pages/Home.vue